window.currentBreakpoint = () => {
	return window
		.getComputedStyle( document.getElementById( 'app-sizer' ), ':before' )
		.content.replaceAll( '"', '' );
};
